/* One ring-size guide across storefront links and dynamically loaded product panels. */
(() => {
  'use strict';
  if (window.JBRingSizeEntryLinks) return;
  window.JBRingSizeEntryLinks = true;
  const tag = document.currentScript;
  const sources = tag?.dataset || {};
  const origins = new Set([location.origin]);
  [sources.shopUrl, sources.shopDomain].forEach(value => {
    try { if (value) origins.add(new URL(value, location.origin).origin); } catch (_) {}
  });
  const guidePath = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/ring-size-guide\/?$/i;
  const components = 'jb-ring-size-experience,jb-ring-sizer,jb-ring-sizer-dialog,jb-ring-size-choice';
  const componentNames = components.split(',');

  function previewId() {
    const theme = window.Shopify?.theme;
    const role = String(theme?.role || '').toLowerCase();
    if (role === 'main') return '';
    const value = ['unpublished', 'development', 'demo'].includes(role)
      ? theme.id : new URL(location.href).searchParams.get('preview_theme_id');
    return /^\d+$/.test(String(value || '')) ? String(value) : '';
  }

  function prepare(link) {
    if (!link || link.hasAttribute('download')) return;
    let url;
    try { url = new URL(link.getAttribute('href'), location.href); } catch (_) { return; }
    if (!/^https?:$/.test(url.protocol) || !origins.has(url.origin) || !guidePath.test(url.pathname)) return;
    // Do not let a draft guide link fall back to the older live-theme guide.
    const preview = previewId();
    if (!preview) return;
    url.protocol = location.protocol;
    url.host = location.host;
    url.searchParams.set('preview_theme_id', preview);
    const destination = url.pathname + url.search + url.hash;
    if (link.getAttribute('href') !== destination) link.setAttribute('href', destination);
  }

  function prepareTree(root) {
    if (root?.matches?.('a[href]')) prepare(root);
    root?.querySelectorAll?.('a[href*="/pages/ring-size-guide"]').forEach(prepare);
  }

  function loadAsset(source, stylesheet) {
    if (!source) return;
    let url;
    try { url = new URL(source, location.href).href; } catch (_) { return; }
    const selector = stylesheet ? 'link[rel="stylesheet"][href]' : 'script[src]';
    if ([...document.querySelectorAll(selector)].some(node => (stylesheet ? node.href : node.src) === url)) return;
    const node = document.createElement(stylesheet ? 'link' : 'script');
    if (stylesheet) { node.rel = 'stylesheet'; node.href = url; }
    else { node.async = false; node.src = url; }
    node.dataset.jbRingSizeAsset = 'true';
    node.addEventListener('error', () => node.remove(), { once: true });
    document.head.append(node);
  }

  function ensureAssets() {
    if (!document.querySelector(components)) return;
    loadAsset(sources.sizerCss, true);
    // Existing measurement logic is reused verbatim; no sizes or variants change.
    if (!customElements.get('jb-ring-sizer')) loadAsset(sources.sizerSrc, false);
    if (!customElements.get('jb-ring-size-experience')) loadAsset(sources.experienceSrc, false);
    if (!customElements.get('jb-ring-size-choice')) loadAsset(sources.choiceSrc, false);
  }

  ['pointerdown', 'focusin', 'contextmenu', 'click', 'auxclick'].forEach(type => {
    document.addEventListener(type, event => {
      prepare(event.target.closest?.('a[href]'));
      if (type === 'click') ensureAssets();
    }, { capture: true, passive: true });
  });

  function initialize() {
    prepareTree(document);
    ensureAssets();
    if (!window.MutationObserver || componentNames.every(name => customElements.get(name))) return;
    const observer = new MutationObserver(records => {
      if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) return;
      ensureAssets();
      if (componentNames.every(name => customElements.get(name))) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    Promise.all(componentNames.map(name => customElements.whenDefined(name))).then(() => observer.disconnect());
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  window.addEventListener('pageshow', event => { if (event.persisted) initialize(); });
  document.addEventListener('shopify:section:load', event => { prepareTree(event.target); ensureAssets(); });
})();
